<template>
  <div class="navigation-menu">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-horizontal"
      mode="horizontal"
      @select="handleSelect"
      router
    >
      <el-menu-item index="/problem/list">
        <el-icon><document /></el-icon>
        <span>题目管理</span>
      </el-menu-item>
      
      <el-sub-menu index="exam">
        <template #title>
          <el-icon><notebook /></el-icon>
          <span>试卷管理</span>
        </template>
        <el-menu-item index="/exam/list">试卷列表</el-menu-item>
        <el-menu-item index="/exam/create">创建试卷</el-menu-item>
      </el-sub-menu>
      
      <el-sub-menu index="dictation">
        <template #title>
          <el-icon><headset /></el-icon>
          <span>英语听写</span>
        </template>
        <el-menu-item index="/dictation/start">听写/描红</el-menu-item>
        <el-menu-item index="/dictation/records">听写记录</el-menu-item>
        <el-menu-item index="/dictation/wrong-sets">错题集</el-menu-item>
      </el-sub-menu>

      <el-menu-item index="/ear-training">
        <el-icon><headset /></el-icon>
        <span>英语磨耳朵</span>
      </el-menu-item>

      <el-menu-item index="/english-learning">
        <el-icon><reading /></el-icon>
        <span>英语学习</span>
      </el-menu-item>
      
      <el-menu-item index="/record/list">
        <el-icon><tickets /></el-icon>
        <span>答题记录</span>
      </el-menu-item>
      
      <el-menu-item index="/oss-files">
        <el-icon><folder /></el-icon>
        <span>OSS文件管理</span>
      </el-menu-item>
      
      <el-menu-item index="/dict/manager">
        <el-icon><management /></el-icon>
        <span>字典维护</span>
      </el-menu-item>
      
      <el-menu-item index="/competition/results">
        <el-icon><trophy /></el-icon>
        <span>比赛结果</span>
      </el-menu-item>
      
      <el-menu-item index="/knowledge-points">
        <el-icon><connection /></el-icon>
        <span>知识点列表</span>
      </el-menu-item>
      
      <el-menu-item index="/settings/speech">
        <el-icon><setting /></el-icon>
        <span>语音设置</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { 
  Document, 
  Notebook, 
  Tickets, 
  Management, 
  Trophy,
  Connection,
  Headset,
  Setting,
  Folder,
  Reading
} from '@element-plus/icons-vue'

const route = useRoute()
const activeIndex = ref(route.path)

// 监听路由变化，更新激活的菜单项
watch(
  () => route.path,
  (newPath) => {
    activeIndex.value = newPath
  }
)

const handleSelect = (key: string) => {
  console.log('选择了菜单项:', key)
}
</script>

<style scoped>
.navigation-menu {
  margin-bottom: 20px;
}

.el-menu-horizontal {
  border: none;
}
</style>